import { createTypes, createAsyncAction } from '../../../flux';


type ActionTypes = {
	'FETCH_TENANT_ENTITIES': string;
};

const types = createTypes<ActionTypes>([
	'FETCH_TENANT_ENTITIES',
], 'BUSINESS:COUNTERPARTY');

const actions = {
	fetchTenantEntities: createAsyncAction<Array<CounterpartyBrief>>(types.FETCH_TENANT_ENTITIES)(
		(box) => box.api.finance.counterparty.counterpartyService.fetchCounterpartyBriefListByFilter({
			selectTenantLegalEntities: true,
		}),
	),
};

export const counterpartyActionsPack = {
	types,
	actions,
};
